<template>
    <div class="brand-swipper-container">
        <CommonComponentsTopicSection type="Brand" />
        <div class="brand-swipper-card-container">
            <div class="brand-swipper-title">
                <div class="title" v-html="$t(data2.title)" />
            </div>
            <div class="global-limited-1360px-container">
                <div class="brand-swipper-card">
                    <div class="brand-swipper-card-scroll">
                        <CommonComponentsCardChallenge
                            v-for="(cardItem, itemIndex) in data.partsInfo"
                            :key="itemIndex"
                            :card-item="cardItem"
                            :index="itemIndex"
                        />
                    </div>
                </div>
            </div>
            <div class="brand-swipper-card-container-mobile">
                <CommonComponentsCardChangingCards
                    :card-data-list="data.partsInfo"
                    :background-image="data.partsInfo"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import png1 from '@assets/imgs/Solutions/Brand/Swipper/planning1.png';
    import png2 from '@assets/imgs/Solutions/Brand/Swipper/development.png';
    import png3 from '@assets/imgs/Solutions/Brand/Swipper/review.png';
    import png4 from '@assets/imgs/Solutions/Brand/Swipper/marketing.png';

    import { matchMobile } from '~~/composables/useMatchRules.ts';
    import { ifCNLocale } from '~~/composables/useLocale.ts';

    const isCN = ifCNLocale();

    interface SupportCustomerSuccessData {
        partsInfo: Array<UnionTitle>;
    }

    const data: SupportCustomerSuccessData = {
        partsInfo: [
            {
                title: 'global_solutions_brand_swipper_card_title_0',
                follow: 'global_solutions_brand_swipper_card_subtitle_0',
                text: 'global_solutions_brand_swipper_card_text_0',
                bgImage: png1,
            },
            {
                title: 'global_solutions_brand_swipper_card_title_1',
                follow: 'global_solutions_brand_swipper_card_subtitle_1',
                text: 'global_solutions_brand_swipper_card_text_1',
                bgImage: png2,
            },
            {
                title: 'global_solutions_brand_swipper_card_title_2',
                follow: 'global_solutions_brand_swipper_card_subtitle_2',
                text: 'global_solutions_brand_swipper_card_text_2',
                bgImage: png3,
            },
            {
                title: 'global_solutions_brand_swipper_card_title_3',
                follow: 'global_solutions_brand_swipper_card_subtitle_3',
                text: 'global_solutions_brand_swipper_card_text_3',
                bgImage: png4,
            },
        ],
    };

    const data2 = reactive({
        title: 'global_solutions_brand_swipper_title_0',
    });
</script>

<style lang="less" scoped>
    .brand-swipper-container {
        // position: relative;
        .brand-swipper-card-container-mobile {
            :deep(.transform-card-title) {
                font-size: .convert(16px) [ @vw-mobile] !important;
            }
            display: none;
            @media (max-width: @screen-mobile-width) {
                display: block;
            }
        }

        .brand-swipper-card-container {
            .brand-swipper {
                &-title {
                    text-align: center;
                    font-size: .convert(@font-size-title-xs) [ @vw]; //36px
                    line-height: 100%;
                    margin: .convert(60px) [ @vw] 0 .convert(40px) [ @vw] 0;
                    font-family: 'HarmonyOS Sans SC';

                    @media (max-width: @screen-mobile-width) {
                        font-size: .convert(@font-size-lg) [ @vw-mobile] !important; //20px
                    }
                }
                &-card {
                    width: 100%;
                    height: .convert(416px) [ @vw];
                    display: flex;
                    overflow: hidden;
                    justify-content: center;
                    @media (max-width: @screen-mobile-width) {
                        display: none;
                        height: auto;
                    }
                    &-scroll {
                        display: flex;
                        gap: .convert(@flex-gap-lg) [ @vw]; //20px
                        overflow-x: scroll;
                        &::-webkit-scrollbar {
                            display: none;
                        }
                        @media (max-width: @screen-mobile-width) {
                            gap: .convert(@flex-gap-sm-sm) [ @vw-mobile]; //10px
                        }
                    }
                }
            }
        }
    }
    :lang(en) {
        .brand-swipper-title {
            font-family: Montserrat !important;
        }
    }
</style>
